import { Outlet } from "react-router-dom";

function DeviceIndex() {
  return (
    <div className="h-full w-full">
      <Outlet />
    </div>
  );
}

export default DeviceIndex;
